export const GLOBAL_PRESET_ACCOUNT_ID = -1;
